import { rpc } from './rpc.js';
export default {
    rpc,
    types: {
        BlockHash: 'Hash'
    }
};
